import { queryOptions } from '@tanstack/react-query';
import { getUserPreferences } from '../api/userPreferences.api';

export function getUserPreferencesQuery(tenantId?: string) {
  return queryOptions({
    queryKey: ['user-preferences', tenantId],
    queryFn: async () => await getUserPreferences(),
  });
}
